import React from "react";
import { ProductsGridProps, ProductHit, toProductHit } from "../../types/searchResults";
import { ProductResult, isProductResult } from "../../search-core/types/ProductResult";
import ProductCard from "./ProductCard";
import { ApiCartService } from "../../services/api-cart-service";

/**
 * ProductsGrid - Displays a grid of product cards
 *
 * Uses CSS grid layout with responsive columns.
 * Shows skeleton loading state when isLoading is true.
 */
const ProductsGrid: React.FC<ProductsGridProps> = ({
	products,
	// isLoading = false,
	className = "",
	// skeletonCount = 8,
	hasMore = false,
}) => {
	// Convert unknown items to valid product objects (ProductHit or ProductResult)
	const validProducts: (ProductHit | ProductResult)[] = React.useMemo(() => {
		return products
			.map((product) => {
				// Check if already ProductResult using type guard
				if (isProductResult(product)) {
					return product;
				}
				// Try to convert to ProductHit using legacy function
				const productHit = toProductHit(product);
				if (productHit) {
					return productHit;
				}
				return null;
			})
			.filter((product): product is ProductHit | ProductResult => product !== null);
	}, [products]);

	const cartService = new ApiCartService();

	const handleAddToCart = async (product: ProductHit | ProductResult) => {
		try {
			const productId = typeof product.id === 'number' ? product.id : parseInt(product.id as string, 10);
			if (isNaN(productId)) {
				console.error('Invalid product ID:', product.id);
				return;
			}
			const response = await cartService.addToCart(productId, 1);
			console.log('Added to cart:', response);
			// TODO: show success notification
		} catch (error) {
			console.error('Failed to add to cart:', error);
			// TODO: show error notification
		}
	};

	// Show loading skeletons
	// if (isLoading) {
	//   return (
	//     <div className={`products-grid ${className}`}>
	//       {Array.from({ length: skeletonCount }).map((_, index) => (
	//         <div key={`skeleton-${index}`} style={styles.skeletonCard}>
	//           <div style={styles.skeletonImage}></div>
	//           <div style={styles.skeletonContent}>
	//             <div style={styles.skeletonText}></div>
	//             <div style={{ ...styles.skeletonText, width: "60%" }}></div>
	//             <div style={styles.skeletonButton}></div>
	//           </div>
	//         </div>
	//       ))}
	//     </div>
	//   );
	// }

	// // Show empty state if no products
	// if (validProducts.length === 0) {
	//   return (
	//     <div
	//       className={`products-grid empty ${className}`}
	//       style={styles.emptyGrid}
	//     >
	//       <div style={styles.emptyMessage}>
	//         <i className="fas fa-search" style={styles.emptyIcon}></i>
	//         <p style={styles.emptyText}>Нет товаров</p>
	//       </div>
	//     </div>
	//   );
	// }
	if (!validProducts || validProducts.length === 0) {
		return null;
	}
	// Show product grid
	return (
		<div className={`products-grid ${className}`}>
			{validProducts.map((product, index) => (
				<ProductCard key={product.id || `product-${index}`} product={product} onActionClick={handleAddToCart} hasMore={hasMore} />
			))}
		</div>
	);
};

// Add CSS animation for skeleton pulse
const styleSheet = document.styleSheets[0];
if (styleSheet) {
	try {
		styleSheet.insertRule(
			`
      @keyframes pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.5; }
      }
    `,
			styleSheet.cssRules.length,
		);
	} catch (e) {
		// Ignore if cannot insert
	}
}

export default ProductsGrid;
